import React, { Component } from 'react';
import config from 'react-global-configuration';

import { BrowserRouter, Redirect, Route, Link } from 'react-router-dom';

// Importação do Bootstrap
import { Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

const PropTypes = require('prop-types');

class Topo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      user: JSON.parse(localStorage.getItem("data")).email,
      moodleCompletionAccess: false
    }

    this.changeMenu = this.changeMenu.bind(this);
    this.logout = this.logout.bind(this);
    this.loadMoodleCompletionPermission = this.loadMoodleCompletionPermission.bind(this);
  }

  componentDidMount() {
    this.loadMoodleCompletionPermission();
  }

  loadMoodleCompletionPermission() {
    var params = JSON.parse(localStorage.getItem("cid"));
    var self = this;

    if (!params || !params.acode) {
      return;
    }

    fetch(config.get('api') + '/moodle/conclusoes-pendentes/permissao', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + params.acode,
      },
    })
      .then(response => response.json())
      .then(responseJson => {
        self.setState({
          moodleCompletionAccess: !!(responseJson && responseJson.status === 'success' && responseJson.data && responseJson.data.allowed === true),
        });
      })
      .catch(() => {
        self.setState({ moodleCompletionAccess: false });
      });
  }

  changeMenu(url) {
    this.context.router.history.push(url);
  }

  logout(e) {
    e.preventDefault();
    localStorage.removeItem("cid");
    this.context.router.history.push('/usuario/login');
  }

  render() {
    return (
      <div>
        <section id="top">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6" id="top-infs">
                Bem-vindo, {this.state.user}- <Link to={'/usuario/login'} onClick={this.logout}>Sair</Link>
              </div>
              <div className="col-xs-12 col-md-6 text-right" id="top-infs">
              </div>
            </div>
          </div>
        </section>
        <section id="header">
          <Navbar collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to={'/'}><img src={config.get('cdn') + '/images/logo1.png'} style={{width: '100%'}} alt="SIGTREIN" /></Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav>
                <NavDropdown eventKey={1} title="Alunos" id="menu-cadastro">
                  <MenuItem header>Alunos</MenuItem>
                  <MenuItem href={'/alunos'} className="menu-links">Lista de alunos</MenuItem>
                  <MenuItem href={'/instrutores'} className="menu-links">Lista de instrutores</MenuItem>
                  <MenuItem href={'/aluno/cadastrar'} className="menu-links">Cadastrar aluno</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Empregadores</MenuItem>
                  <MenuItem href={'/empregadores'} className="menu-links">Lista de empregadores</MenuItem>
                  <MenuItem href={'/empregador/cadastrar'} className="menu-links">Cadastrar empregador</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={2} title="Turmas" id="menu-turma">
                  <MenuItem header>Turmas</MenuItem>
                  <MenuItem href={'/turmas'} className="menu-links">Lista de turmas</MenuItem>
                  <MenuItem href={'/turmas/canceladas'} className="menu-links">Lista de turmas canceladas</MenuItem>
                  <MenuItem href={'/turma/cadastrar'} className="menu-links">Cadastrar turmas</MenuItem>
                  <MenuItem href={'/turmas/erros/integracao'} className="menu-links">Falhas de integração</MenuItem>
                  {this.state.moodleCompletionAccess
                    ? <MenuItem href={'/moodle/conclusoes-pendentes'} className="menu-links">Acompanhamento de conclusão no Moodle</MenuItem>
                    : null}
                  <MenuItem divider />
                  <MenuItem header>Comunicados</MenuItem>
                  <MenuItem href={'/sigtrip/comunicados/nao/lidos'} className="menu-links">Lista de comunicados não lidos - SIGTRIP</MenuItem>
                  <MenuItem href={'/sigtrip/comunicados/lidos'} className="menu-links">Lista de comunicados lidos - SIGTRIP</MenuItem>
                  <MenuItem href={'/sigmec/comunicados/nao/lidos'} className="menu-links">Lista de comunicados não lidos - SIGMEC</MenuItem>
                  <MenuItem href={'/sigmec/comunicados/lidos'} className="menu-links">Lista de comunicados lidos - SIGMEC</MenuItem>
                  <MenuItem href={'/moodle/periodos/missao'} className="menu-links">Períodos Moodle por missão</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={1} title="Treinamentos" id="menu-cadastro">
                  <MenuItem header>Matérias</MenuItem>
                  <MenuItem href={'/materias'} className="menu-links">Lista de matérias</MenuItem>
                  <MenuItem href={'/materias/arquivadas'} className="menu-links">Lista de matérias arquivadas</MenuItem>
                  <MenuItem href={'/materia/cadastrar'} className="menu-links">Cadastrar matéria</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Treinamentos</MenuItem>
                  <MenuItem href={'/treinamentos'} className="menu-links">Lista de treinamentos</MenuItem>
                  <MenuItem href={'/treinamento/cadastrar'} className="menu-links">Cadastrar treinamento</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Materiais</MenuItem>
                  <MenuItem href={'/materiais'} className="menu-links">Lista de materiais</MenuItem>
                  <MenuItem href={'/material/cadastrar'} className="menu-links">Cadastrar material</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={1} title="Provas" id="menu-cadastro">
                  <MenuItem header>Provas</MenuItem>
                  <MenuItem href={'/provas/listagem'} className="menu-links">Lista de provas</MenuItem>
                  <MenuItem href={'/provas/arquivadas/listagem'} className="menu-links">Lista de provas arquivadas</MenuItem>
                  <MenuItem href={'/prova/cadastrar'} className="menu-links">Lançar prova avulsa</MenuItem>
                  <MenuItem href={'/prova/nao/relacionada'} className="menu-links">Lançar prova não relacionada</MenuItem>
                  <MenuItem href={'/provas/nao/relacionadas/listagem'} className="menu-links">Lista de provas não relacionadas</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Questões</MenuItem>
                  <MenuItem href={'/questoes'} className="menu-links">Lista de questões</MenuItem>
                  <MenuItem href={'/questao/cadastrar'} className="menu-links">Cadastrar questão</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Categorias de questão</MenuItem>
                  <MenuItem href={'/categorias'} className="menu-links">Lista de categorias</MenuItem>
                  <MenuItem href={'/categoria/cadastrar'} className="menu-links">Cadastrar categoria</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Configurações de prova</MenuItem>
                  <MenuItem href={'/questoes/dificuldades'} className="menu-links">Lista de dificuldade de questões</MenuItem>
                  <MenuItem href={'/provas/dificuldades'} className="menu-links">Lista de dificuldade de provas</MenuItem>
                  <MenuItem href={'/configuracoes'} className="menu-links">Configurações</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={1} title="Tarefas" id="menu-cadastro">
                  <MenuItem header>Tarefas</MenuItem>
                  <MenuItem href={'/turmas/tarefas'} className="menu-links">Lista de tarefas</MenuItem>
                </NavDropdown>
              </Nav>
              <Nav pullRight>
                <NavDropdown eventKey={3} title={<i className="fa fa-fw fa-cog"></i>} id="menu-cadastro">
                  <MenuItem header>Frotas</MenuItem>
                  <MenuItem href={'/frotas'} className="menu-links">Lista de frotas</MenuItem>
                  <MenuItem href={'/frota/cadastrar'} className="menu-links">Cadastrar frota</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>E-mails</MenuItem>
                  <MenuItem href={'/emails'} className="menu-links">Lista de e-mails</MenuItem>
                  <MenuItem href={'/email/cadastrar'} className="menu-links">Cadastrar e-mail</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Importações</MenuItem>
                  <MenuItem href={'/importar'} className="menu-links">Importar</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Geral</MenuItem>
                  <MenuItem href={'/funcoes'} className="menu-links">Funções</MenuItem>
                  <MenuItem href={'/descricao/nomes/curtos'} className="menu-links">Descrição de Nomes curtos</MenuItem>
                  <MenuItem href={'/config/moodle'} className="menu-links">Configurações Moodle</MenuItem>
                  <MenuItem href={'/publico_alvo'} className="menu-links">Público Alvo</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Controle e aplicação</MenuItem>
                  <MenuItem href={config.get('control')} className="menu-links">Controle de provas</MenuItem>
                  <MenuItem href={config.get('exam')} className="menu-links">Aplicação de prova</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Usuários do Sistema</MenuItem>
                  <MenuItem href={'/usuarios'} className="menu-links">Lista de usuários</MenuItem>
                  <MenuItem href={'/usuarios/alunos'} className="menu-links">Lista de usuários de alunos</MenuItem>
                  <MenuItem href={'/usuario/cadastrar'} className="menu-links">Cadastrar usuário</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Usuários do Sistema</MenuItem>
                  <MenuItem href={'/certificados/sigtrip'} className="menu-links">Certificados - SIGTRIP</MenuItem>
                  <MenuItem href={'/certificados/sigmec'} className="menu-links">Certificados - SIGMEC</MenuItem>
                  <MenuItem href={'/certificados/materias'} className="menu-links">Matérias Relacionada</MenuItem>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </section>
      </div>
    );
  }
}

Topo.contextTypes = {
  router: React.PropTypes.object.isRequired
}


export default Topo;



// WEBPACK FOOTER //
// ./src/Components/Layout/Topo.js